/* globals videojs, window */
const $ = require('jquery');

class VideoBg {
  constructor() {
    this.videosBg = [];
  }

  goToEnd(start, end, player) {
    player.currentTime(start);
    setTimeout(() => {
      this.goToEnd(start, end, player);
    }, (end - start) * 1000);
  }

  loopVideo(start, end, player) {
    player.currentTime(start);
    if (end) {
      setTimeout(() => {
        this.goToEnd(start, end, player);
      }, (end - start) * 1000);
    }
  }

  onResize() {
    this.videosBg.forEach(videoBg => {
      const { ratio } = videoBg;
      const containerWidth = $(videoBg.parentDomElement)
        .parent()
        .width();
      const containerHeight = $(videoBg.parentDomElement)
        .parent()
        .height();
      const videoHeight = containerWidth / ratio;

      const videoPlacehoder = $(videoBg.parentDomElement).find(
        '.mammouth_video_background__placeholder',
      );
      if (videoHeight > containerHeight) {
        videoBg.player.width(containerWidth);
        const topPos = parseInt((containerHeight - videoHeight) / 2, 10);
        $(videoBg.parentDomElement).css('top', `${topPos}px`);
        $(videoBg.parentDomElement).css('left', '0px');
      }
      if (videoHeight < containerHeight) {
        videoBg.player.width(containerHeight * ratio);
        const leftPos = parseInt(
          (containerWidth - containerHeight * ratio) / 2,
          10,
        );
        $(videoBg.parentDomElement).css('left', `${leftPos}px`);
        $(videoBg.parentDomElement).css('top', '0px');
      }
      setTimeout(() => {
        if (!videoPlacehoder.hasClass('transparent')) {
          videoPlacehoder.addClass('transparent');
        }
      }, 500);
    });
  }

  init() {
    this.videosBg = [];
    $('.mammouth_video_background').each((index, parentDomElement) => {
      const playerId = parentDomElement.dataset.id;
      const player = videojs(playerId, { children: { loadingSpinner: false } });
      player.ready(() => {
        if (window.innerWidth > 1050) {
          const isYoutube = player.currentSrc().includes('youtube');
          let videoHeight = player.videoHeight();
          let videoWidth = player.videoWidth();
          const start = parentDomElement.dataset.start
            ? parseInt(parentDomElement.dataset.start, 10)
            : 0;
          const end = parentDomElement.dataset.end
            ? parseInt(parentDomElement.dataset.end, 10)
            : 0;
          if (isYoutube) {
            videoWidth = parseInt(parentDomElement.dataset.width, 10);
            videoHeight = parseInt(parentDomElement.dataset.height, 10);
            setTimeout(() => {
              this.loopVideo(start, end, player);
            }, 750);
          } else {
            this.loopVideo(start, end, player);
          }
          player.play();
          const tempVideo = {
            parentDomElement,
            player,
            videoHeight,
            videoWidth,
            ratio: videoWidth / videoHeight,
            index,
            isYoutube,
            start,
            end,
          };
          this.videosBg.push(tempVideo);
          if (this.videosBg.length === $('.mammouth_video_background').length) {
            this.onResize();
          }
        }
      });
    });
  }
}

export default (() => new VideoBg())();
